import React from 'react';
import { Form } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

const Password = ({ controlId, label, isInvalid, value, onChange, errorMessage, disabled = false }) => (
    <FloatingLabel
        controlId={controlId}
        isInvalid={isInvalid}
        label={label}
        onChange={onChange}
        disabled={disabled}
        className="mb-3"
    >
        <Form.Control size="lg" label={label} value={value} type="password" placeholder={label} />
        {errorMessage && <span className='text-danger'>{errorMessage}</span>}
    </FloatingLabel>
);

export default Password;
